import {
  ArticleWithMediaCount,
  EdsData,
  SalesStopData,
} from "@coworker/app/src/components/RoomSettings/types/article";
import { isLocalCombinationArticle } from "@coworker/app/src/components/RoomSettings/Helpers/articleHelpers";
import { ArticleType } from "@coworker/types/lib/tasks/constants";
import { MediaItemCardLocalCombinationSearch } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/MediaItemCardLocalCombinationSearch/MediaItemCardLocalCombinationSearch";
import { getMediaItemBadges } from "@coworker/apprestructured/src/media-maintenance/helpers/getMediaItemBadges";
import { useTranslation } from "@coworker/locales";
import { MediaItemCardSearch } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/MediaItemCardSearch/MediaItemCardSearch";
import { useItemInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemInfo";
import SimpleArticleCardSkeleton from "@coworker/apprestructured/src/shared/simple/SimpleSkeleton/SimpleArticleCardSkeleton";

interface ItemListViewItemSearchProps {
  article: ArticleWithMediaCount;
  hasOngoingTasks: boolean;
  salesStopData?: SalesStopData | null;
  edsData?: EdsData | null;
}

export const ItemListViewItemSearch = ({
  article,
  hasOngoingTasks,
  salesStopData,
  edsData,
}: ItemListViewItemSearchProps) => {
  const isLocalCombinationItem = isLocalCombinationArticle(
    article?.productArticleType as ArticleType
  );
  const { t } = useTranslation();

  const { data: itemInfo, isLoading: isLoadingItemInfo } = useItemInfo(
    article.productArticleId
  );

  const badges = getMediaItemBadges(
    article.id,
    [article.id],
    t,
    hasOngoingTasks,
    salesStopData,
    undefined,
    false
  );

  if (isLocalCombinationItem) {
    return (
      <MediaItemCardLocalCombinationSearch
        badges={badges}
        article={article}
        edsData={edsData ?? null}
      />
    );
  }

  return (
    <>
      {isLoadingItemInfo && <SimpleArticleCardSkeleton />}
      {!isLoadingItemInfo && itemInfo && (
        <MediaItemCardSearch
          item={itemInfo}
          edsData={edsData ?? null}
          amountOfMedias={article.inAmountOfMedias}
        />
      )}
    </>
  );
};
